import AxiosInstance from "@/components/Axios"

export const GetUserPreferencesFromAPI = async (email: string) => {
    const response = await AxiosInstance.get("/api/user/preferences", {
        params: {
            email: email
        }
    })

    if (response.status === 200) {
        return response.data
    }

    throw new Error("Failed to get user preferences")
}